const auditCompletionEvents = {
    Started: {
        Name: "AUDITSUBMISSION.STARTED",
        New() {
            return {
                type: auditCompletionEvents.Started.Name
            };
        }
    },
    Completed: {
        Name: "AUDITSUBMISSION.TRANSITIONED",
        New(surveyType, facilityNumber, surveyID) {
            return {
                type: auditCompletionEvents.Completed.Name,
                SurveyType: surveyType,
                FacilityNumber: facilityNumber,
                SurveyID: surveyID
            };
        }
    },
    SampleScore: { 
        Name: "AUDIT.SAMPLESCORE",
        New(Score, MaxScore) {
            return {
                type: auditCompletionEvents.SampleScore.Name, 
                score: Score,
                maxScore: MaxScore
            }
        }
    },
    SampleScoreErrored: { 
        Name: "AUDIT.SAMPLESCOREERRORED",
        New(ex) {
            return {
                type: auditCompletionEvents.SampleScoreErrored.Name,
                Error: ex
            }; 
        }
    }, 
    Errored: {
        Name: "AUDITSUBMISSION.ERRORED",
        New(ex) {
            return {
                type: auditCompletionEvents.Errored.Name,
                Error: ex
            };
        }
    },
    ErrorCleared: {
        Name: "AUDITSUBMISSION.ERRORCLEARED",
        New() {
            return {
                type: auditCompletionEvents.ErrorCleared.Name
            };
        }
    }
};

module.exports = auditCompletionEvents;


// WEBPACK FOOTER //
// ./src/events/auditCompletion/auditCompletionEvents.js